import React from "react";
import BannerImage from "../components/BannerImage";

const TransformingUrbanSpaces = () => {

return(
    <div>
        <div>
            <BannerImage
        src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1200&q=80"
        alt="Our Work Banner"
      />
        </div>
        this transforming page
    </div>
)

}
export default TransformingUrbanSpaces;